import { Component, OnInit, Input } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';
import { FormControl } from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-ent-queue-selector',
  templateUrl: './ent-queue-selector.component.html',
  styleUrls: ['./ent-queue-selector.component.css']
})
export class EntQueueSelectorComponent implements OnInit {

  @Input() public queueModel: any;
  @Input() public overflow: boolean;

  queueControl = new FormControl();
  filteredOptions: Observable<any[]>;
  queueOptions = [];

  constructor(
    public configService: ConfigService,
  ) { }

  async ngOnInit() {
    await this.configService.getQueueList();
    this.configService.queueNamesList.map((queue: any) => {
      if (!this.configService.configList.includes(queue['queueName'])) {
        this.queueOptions.push(queue);
      }
    })
    this.filteredOptions = this.queueControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: any): string[] {
    console.log('Filtering', value);
    const filterValue = value.toLowerCase();
    return this.queueOptions.filter((option: any) => option['queueName'].toLowerCase().indexOf(filterValue) === 0);
  }

  updateQueueArn(event: any) {
    console.log(event);
    this.configService.activeConfigData.ConfigKey = event;
    console.log(this.configService.activeConfigData);
  }

}
